import { Autocomplete, Box, Typography } from "@mui/material";
import { JsonMaster } from "common/interfaces/JsonMaster";
import React from "react";
import { AutocompleteRenderInputTextBox } from "../AutocompleteRenderInputTextBox";
import { useStructureForPricingAutocompleteHooks } from "./hooks";
import { StructureForPricingAutocompleteProps } from "./interfaces";

const StructureForPricingAutocompleteImplements = <
  Multiple extends boolean | undefined,
  DisableClearable extends boolean | undefined,
  FreeSolo extends boolean | undefined
>(
  props: StructureForPricingAutocompleteProps<
    JsonMaster,
    Multiple,
    DisableClearable,
    FreeSolo
  >
) => {
  const {
    jsonMasters,
    referenceStyles,
    getOptionLabel,
    getOptionSelected,
    convertValue
  } = useStructureForPricingAutocompleteHooks<
    JsonMaster,
    Multiple,
    DisableClearable,
    FreeSolo
  >(props.multiple, props.setFatal, props.onOptionsLoad);

  const {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    label: _label,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    helperText: _helperText,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    errorMessage: _errorMessage,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    referenceText: _referenceText,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    required: _required,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    InputProps: _InputProps,
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    onOptionsLoad: _onOptionsLoad,
    ...autocompleteProps
  } = props;

  delete autocompleteProps.setFatal;

  return (
    <>
      <Autocomplete
        {...autocompleteProps}
        getOptionLabel={getOptionLabel}
        renderInput={(params) => (
          <AutocompleteRenderInputTextBox
            params={params}
            label={props.label}
            helperText={props.helperText}
            errorMessage={props.errorMessage}
            referenceText={props.referenceText}
            required={props.required}
            InputProps={props.InputProps}
          />
        )}
        options={jsonMasters}
        value={convertValue(props.value)}
        isOptionEqualToValue={getOptionSelected}
        disabled={jsonMasters.length === 0 || props.disabled}
        noOptionsText={<i>候補が見つかりません</i>}
      ></Autocomplete>
      <Box sx={referenceStyles}>
        <Typography variant="caption">{props.referenceText}</Typography>
      </Box>
    </>
  );
};

export const StructureForPricingAutocomplete = React.memo(
  StructureForPricingAutocompleteImplements
) as typeof StructureForPricingAutocompleteImplements;
